import type { TransformEntry } from "../facet-form-config";

export function pruneNormalizeTransform(
    entries: TransformEntry[] | undefined,
    keyOptions: string[],
    partyOptions: string[]
): TransformEntry[] {
    const pruned = (entries ?? [])
        .map((e) => ({
            key: keyOptions.includes(e.key) ? e.key : "",
            value: partyOptions.includes(e.value) ? e.value : "",
        }))
        .filter((e) => e.key !== "" || e.value !== "");
    return pruned.length > 0 ? pruned : [{ key: "", value: "" }];
}
